const errorTranslations = {
  "errors.failedToSendInformation": "Failed to send information",
};

export default errorTranslations;
